<template>
  <div class="main">
    <my_menu active_name="1-0" :open_active="['1']"></my_menu>

    <div class="content">
      <div class="content_tabs">
        <Tabs v-model="current_tab" @on-click="click_tab">
          <TabPane label="正常用户" name="0"></TabPane>

          <TabPane label="停用用户" name="1"></TabPane>

          <TabPane label="已删除" name="2"></TabPane>
        </Tabs>
      </div>

      <div class="options">
        <div class="options_txt">
          当前用户总数：{{ total_count }}人

          <Select v-model="user_type" style="width: 120px; margin: 0 10px" size="small" @on-change="user_type_change">
            <Option value="0">常规用户</Option>

            <Option value="1">测试用户</Option>

            <Option value="2">消息用户</Option>
          </Select>

          <Input size="small" v-model="search_name" placeholder="搜索名称" style="width: 100px" @on-search="search"
            @on-enter="search">
          <template #suffix>
            <Icon type="ios-search" />
          </template>
          </Input>
        </div>
        <div>
          <Button style="font-size: 10px; margin-right: 10px" size="small" @click="user_jicheng_click" type="success"
            icon="logo-dribbble">离职继承</Button>
          <Button v-if="current_tab == 0" style="font-size: 10px; margin-right: 10px" size="small"
            @click="deactivate_account" type="error" icon="md-trash">帐号停用</Button>
          <Button style="font-size: 10px; margin-right: 10px" size="small" @click="add_auth_show = true" type="primary"
            icon="md-add">添加权限</Button>
          <Button style="font-size: 10px" size="small" @click="add_user_show = true" type="primary"
            icon="md-add">添加用户</Button>
          <Button v-if="current_tab == 1" style="font-size: 10px; margin-left: 10px" size="small"
            @click="jiechu_deactivate_account" type="success">解除停用</Button>
        </div>
      </div>
      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>
        <Table size="small" :height="windowHeight - 165" border :columns="columns" :data="table_data"
          @on-selection-change="table_selection_change">
          <template #name="{ row }">
            <div class="name_box">
              <div style="width: 90px">{{ row.name }}</div>

              <div class="avatar_div" @click="update_avatar(row)">
                <Avatar size="small" :src="row.avatar" />
              </div>
            </div>
          </template>
          <template #update_phone="{ row }">
            <div class="name_box">
              <span class="reset_pwd" @click="update_phone(row)">更新手机号</span>
            </div>
          </template>

          <template #user_role_list="{ row, index }">
            <div class="user_role_box">
              <Tag color="success" v-for="(item, i) in row.user_role_list" :key="String(i)" :name="String(i)" closable
                @on-close="subtract_role(row, item)">{{ item.name }}
              </Tag>
            </div>
          </template>

          <template #action="{ row, index }">
            <div class="user_role_box">
              <span class="reset_pwd" @click="reset_pwd(row)">重置密码</span>
            </div>
          </template>

          <template #sms_login_status="{ row, index }">
            <div class="user_role_box">
              <span class="" v-if="row.sms_login_status == 0">正常

                <Icon color="green" type="md-checkmark-circle" />
              </span>

              <span class="reset_pwd" @click="unlock_account(row.user_id)" v-if="row.sms_login_status == 1">锁定

                <Icon color="red" type="md-lock" />
              </span>
            </div>
          </template>
        </Table>
        <div class="content_page">
          <Page v-model="page" :total="total_count" :page-size="page_size" @on-change="page_change" />
        </div>
      </div>
    </div>
  </div>

  <Modal width="420" v-model="update_avatar_show" title="更新头像" :footer-hide="true">
    <div>
      <Upload ref="avatar_update" :action="update_avatar_upload_url + update_avatar_user_id"
        :on-success="success_avatar">
        <Button icon="ios-cloud-upload-outline">上传头像</Button>
      </Upload>
    </div>
  </Modal>

  <Modal width="420" v-model="add_user_show" title="添加新用户" :footer-hide="true">
    <div>
      <Form ref="add_sys" :model="add_user_data" :rules="add_user_rules" inline>
        <FormItem prop="name">
          <div class="form_item">
            <div class="form_item_title">*登录手机号：</div>
            <Input style="width: 250px" maxlength="11" type="text" v-model="add_user_data.phone"
              placeholder="请输入11位手机号">
            </Input>
          </div>
        </FormItem>
        <FormItem prop="dx_sys_id">
          <div class="form_item">
            <div class="form_item_title">*姓名：</div>
            <Input style="width: 250px" type="text" v-model="add_user_data.name" placeholder="请输入">
            </Input>
          </div>
        </FormItem>
        <FormItem prop="dx_sys_id">
          <div class="form_item">
            <div class="form_item_title">数据归属部门：</div>
            <Input style="width: 250px" type="text" v-model="add_user_data.dep_id" placeholder="请输入">
            </Input>
          </div>
        </FormItem>
        <FormItem prop="dx_sys_id">
          <div class="form_item">
            <div class="form_item_title">用户id：</div>
            <Input style="width: 250px" type="text" v-model="add_user_data.user_id" placeholder="请输入">
            </Input>
          </div>
        </FormItem>
        <div class="add_sys_button">
          <Button type="primary" @click="add_user_ok()">确认添加</Button>
        </div>
      </Form>
    </div>
  </Modal>

  <Modal width="420" v-model="add_auth_show" title="添加新权限" :footer-hide="true">
    <div class="select_box">
      选择角色：
      <Select v-model="select_role_id" style="width: 200px">
        <OptionGroup :label="k" v-for="(v, k) in options_dict" :key="k">
          <Option :value="oitem.value" v-for="(oitem, oindex) in v" :key="oindex">{{
            oitem.label
          }}</Option>
        </OptionGroup>
      </Select>
    </div>
    <div class="button_box">
      <Button type="primary" @click="affirm_add_role">确认添加</Button>
    </div>
  </Modal>

  <Modal width="420" v-model="update_phone_show" title="更新手机号" :footer-hide="true">
    <div class="select_box">
      <Input v-model="new_phone" placeholder="请输入新手机号.." style="width: 300px" />


    </div>
    <div class="button_box">
      <Button type="primary" @click="update_phone_request">确认更新</Button>
    </div>
  </Modal>

  <Modal width="420" v-model="jicheng_show" title="离职继承" :footer-hide="true">
    <div>
      <div>老用户userid:</div>
      <Input v-model="jicheng_old_user_id" placeholder="请输入user_id..." clearable style="width: 350px" />
    </div>
    <div style="margin-top: 10px">
      <div>新用户userid:</div>
      <Input v-model="jicheng_new_user_id" placeholder="请输入user_id..." clearable style="width: 350px" />
    </div>
    <div class="button_box">
      <Button type="primary" @click="user_jicheng">确认添加</Button>
    </div>
  </Modal>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,
      page_size: 20,
      total_count: 0,
      current_tab: 0,
      add_user_show: false,
      add_user_data: {
        phone: "",
        name: "",
        dep_id: "",
        user_id: "",
      },
      add_user_rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 18,
            message: "请输入6-18位用户名",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 18,
            message: "请输入6-18位密码",
            trigger: "blur",
          },
        ],
      },
      //选中的数据
      table_selection: [],
      //角色数据
      options_dict: [],

      add_auth_show: false,
      select_role_id: "",

      search_name: "",
      jicheng_show: false,

      jicheng_old_user_id: "",
      jicheng_new_user_id: "",

      user_type: "0",
      update_avatar_show: false,
      update_avatar_user_id: "",
      update_avatar_upload_url:
        process.env.VUE_APP_HOST +
        "/user_manage/update_avatar?token=" +
        this.$cookies.get("admin_token") +
        "&user_id=",

      update_phone_item: {},
      update_phone_show: false,
      new_phone: ''
    };
  },

  mounted() {
    this.window_change();
    this.get_user_list();
    this.get_role_options();
  },

  methods: {
    update_phone_request() {
      var that = this;
      var obj = {
        user_id: this.update_phone_item.user_id,
        new_phone: this.new_phone,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/user_phone_update", obj, true)
        .then((res) => {
          if (res.code == 0) {

            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
           
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_phone(item) {
      this.update_phone_show = true
      this.update_phone_item = item

    },
    success_avatar(e) {
      this.$refs.avatar_update.clearFiles();
      this.$Message.success(e.msg);
      this.update_avatar_show = false;
    },

    update_avatar(item) {
      this.update_avatar_user_id = item.user_id;
      this.update_avatar_show = true;
    },

    user_type_change() {
      this.get_user_list();
    },

    user_jicheng_click() {
      this.jicheng_show = true;
    },

    //离职继承
    user_jicheng() {
      if (this.jicheng_old_user_id == "") {
        this.$Message.error("请输入用户id");
        return;
      }
      if (this.jicheng_new_user_id == "") {
        this.$Message.error("请输入用户id");
        return;
      }

      var that = this;
      var obj = {
        old_user_id: this.jicheng_old_user_id,
        new_user_id: this.jicheng_new_user_id,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/lizhi_jicheng", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.page = 1;
            that.jicheng_show = false;
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    unlock_account(user_id) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在解除锁定，要继续吗？</p>",
        onOk: () => {
          that.unlock_account_sms_request(user_id);
        },
        onCancel: () => { },
      });
    },

    //解锁帐号
    unlock_account_sms_request(user_id) {
      var that = this;
      var obj = {
        user_id: user_id,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/user_unlock_sms", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.page = 1;
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    deactivate_account() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择用户");
        return;
      }

      var user_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var select_data = this.table_selection[i];
        user_id_list.push(select_data["user_id"]);
      }

      var that = this;
      var obj = {
        user_id_list: user_id_list,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/deactivate_account",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.page = 1;
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    deactivate_account() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择用户");
        return;
      }

      var user_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var select_data = this.table_selection[i];
        user_id_list.push(select_data["user_id"]);
      }

      var that = this;
      var obj = {
        user_id_list: user_id_list,
        status: 1,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/deactivate_account",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.page = 1;
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    jiechu_deactivate_account() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择用户");
        return;
      }

      var user_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var select_data = this.table_selection[i];
        user_id_list.push(select_data["user_id"]);
      }

      var that = this;
      var obj = {
        user_id_list: user_id_list,
        status: 0,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/user_manage/deactivate_account",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.page = 1;
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //添加用户
    add_user_ok() {
      var that = this;
      if (this.add_user_data.phone == "") {
        that.$Message.error({
          content: "请输入手机号",
          duration: 3,
        });
        return;
      }
      if (this.add_user_data.name == "") {
        that.$Message.error({
          content: "请输入姓名",
          duration: 3,
        });
        return;
      }
      // if (this.add_user_data.dep_id == '') {
      //     that.$Message.error({
      //         content: '请输入数据归属部门id',
      //         duration: 3,
      //     });
      // }
      var obj = {
        user_id: this.add_user_data.user_id,
        phone: this.add_user_data.phone,
        name: this.add_user_data.name,
        dep_id: this.add_user_data.dep_id,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/add_user", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_user_show = false;

            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search() {
      console.log("搜索事件");
      this.page = 1;
      this.get_user_list();
    },

    reset_pwd(item) {
      var user_id = item.user_id;
      var that = this;
      var obj = {
        user_id: user_id,
      };
      this.$Modal.error({
        title: "危险操作",
        content: "<p>您正在重置密码，确认继续吗？</p>",
        okText: "OK",
        cancelText: "Cancel",
      });
      this.$Modal.confirm({
        title: "危险操作",
        content: "<p>您正在重置密码，确认继续吗？</p>",
        onOk: () => {
          http(
            "post",
            process.env.VUE_APP_HOST + "/user_manage/reset_password",
            obj,
            true
          )
            .then((res) => {
              if (res.code == 0) {
                that.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
                this.$Notice.open({
                  duration: 0,
                  title: "重置密码成功",
                  desc: "新密码为：" + res.data.password + ",请妥善保存！",
                });

                that.get_user_list();
              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {
              console.log(res, "请求出错");
            });
        },
        onCancel: () => { },
      });
    },

    //减少权限
    subtract_role(row, item) {
      var that = this;
      var obj = {
        role_id: item.role_id,
        user_id: row.user_id,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/subtract_role", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_user_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //确认添加权限
    affirm_add_role() {
      if (this.table_selection.length == 0) {
        this.$Message.error("请选择用户");
        return;
      }
      if (this.select_role_id == "") {
        this.$Message.error("请选择角色");
        return;
      }
      var user_id_list = [];
      for (let i = 0; i < this.table_selection.length; i++) {
        var select_data = this.table_selection[i];
        user_id_list.push(select_data["user_id"]);
      }
      console.log(user_id_list);

      var that = this;
      var obj = {
        role_id: this.select_role_id,
        user_id_list: user_id_list,
      };
      http("post", process.env.VUE_APP_HOST + "/user_manage/add_role", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_user_list();
            that.add_auth_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取角色列表
    get_role_options() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/user_manage/role_option", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.options_dict = res.data.options_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    table_selection_change(e) {
      this.table_selection = e;
      console.log(e);
    },

    click_tab(e) {
      this.get_user_list();
      this.table_selection = [];
    },

    page_change(e) {
      this.page = e;
      this.get_user_list();
    },

    //获取用户列表
    get_user_list() {
      var that = this;
      var obj = {
        name: this.search_name,
        page: this.page,
        status: Number(this.current_tab),
        user_type: this.user_type,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/user_manage/user_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.table_data;
            that.columns = res.data.columns;
            that.total_count = res.data.total_count;
            that.page_size = res.data.page_size;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.reset_pwd {
  color: #0466dd;
  cursor: pointer;
}

.button_box {
  margin-top: 20px;
  display: flex;
  justify-content: right;
}

.select_box {
  justify-content: center;
  display: flex;
  align-items: center;
}

.user_role_box {
  display: flex;
  flex-wrap: wrap;
}

.options_txt {
  font-size: 12px;
  padding-left: 10px;
}

.avatar_div {
  flex-shrink: 0;
  width: 20px;
  cursor: pointer;
}

.name_box {
  display: flex;
  align-items: center;
}

.dimission_line {
  background-color: red;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
}

.content {
  padding: 10px;
  width: calc(100% - 220px);
  background-color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
